import loadable from '@loadable/component';

export const NotFoundContentLoadable = loadable(
  () => import('./NotFoundContent'),
  { resolveComponent: (module) => module.NotFoundContent },
);
